import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const LANGUAGES = ["Marathi", "Hindi", "English", "Other regional languages on brief"];

const WA_LINK =
  "https://wa.me/918850845977?text=Hi%20Goshta%2C%20I%27d%20like%20to%20discuss%20a%20production%20brief%20or%20a%20story%20idea.";

export default function GoshtaContact() {
  return (
    <section
      id="contact"
      data-testid="goshta-contact"
      className="relative scroll-mt-24 bg-[#050505] py-24 md:py-36"
    >
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <Reveal>
          <ul className="flex flex-wrap gap-2.5" data-testid="goshta-languages">
            {LANGUAGES.map((l) => (
              <li
                key={l}
                className="border border-[#B79045]/40 px-4 py-2 font-mono text-[10px] uppercase tracking-[0.2em] text-[#D4AF37]"
              >
                {l}
              </li>
            ))}
          </ul>
        </Reveal>

        <Reveal delay={0.1}>
          <h2 className="mt-14 max-w-4xl font-display text-4xl font-medium leading-[1.05] tracking-tight text-neutral-100 sm:text-5xl lg:text-6xl">
            Have a brief, a script—or just the{" "}
            <em className="italic text-[#D4AF37]">beginning of an idea?</em>
          </h2>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-neutral-400">
            Tell us what you are building. We can discuss production requirements, story
            development or a combined approach.
          </p>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="mt-12 flex flex-wrap items-center gap-4">
            <a
              data-testid="goshta-email-cta"
              href="mailto:suyog@veritasadvisory.co.in?subject=Enquiry%20—%20Goshta"
              className="inline-flex items-center gap-2 bg-[#B79045] px-8 py-4 font-mono text-[11px] uppercase tracking-[0.2em] text-black transition-colors duration-300 hover:bg-[#D4AF37]"
            >
              Email Us <ArrowUpRight size={14} />
            </a>
            <a
              data-testid="goshta-whatsapp-cta"
              href={WA_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 border border-[#B79045]/60 px-8 py-4 font-mono text-[11px] uppercase tracking-[0.2em] text-[#D4AF37] transition-colors duration-300 hover:bg-[#B79045] hover:text-black"
            >
              WhatsApp Us <ArrowUpRight size={14} />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
